<template>
  <div class="row">
      <div class="col-12">
          <div class="row">
              <div class="col-sm-12">
                  <div class="card">
                      <div class="card-body">
                          <div class="card-header-2">
                              <h5>Blog Information</h5>
                          </div>

                          <v-form class="theme-form theme-form-2 mega-form" ref="form">
                              <div class="row">
                                  <div class="mb-4 row align-items-center">
                                      <label class="form-label-title col-sm-2 mb-0">Author</label>
                                      <div class="col-sm-10">
                                          <v-text-field placeholder="Author" v-model="author"></v-text-field>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="mb-4 row align-items-center">
                                      <label class="form-label-title col-sm-2 mb-0">Title</label>
                                      <div class="col-sm-10">
                                          <v-card>
                                              <v-tabs v-model="tabLanguageTitle" color="deep-purple-accent-4">
                                                  <v-tab value="titleEn">Ingles</v-tab>
                                                  <v-tab value="titleEs">Español</v-tab>
                                                  <v-tab value="titleFr">Frances</v-tab>
                                              </v-tabs>
                                              <v-window v-model="tabLanguageTitle">
                                                  <v-text-field v-if="tabLanguageTitle === 'titleEn'"
                                                      placeholder="Title ingles" v-model="titleEn" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                                  <v-text-field v-if="tabLanguageTitle === 'titleEs'"
                                                      placeholder="Title español" v-model="titleEs" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                                  <v-text-field v-if="tabLanguageTitle === 'titleFr'"
                                                      placeholder="Titre français" v-model="titleFr" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                              </v-window>
                                          </v-card>
                                      </div>
                                  </div>
                              </div>

                              <div class="row">
                                  <div class="col-12">
                                      <div class="row">
                                          <label class="form-label-title col-sm-2 mb-0">Content</label>
                                          <div class="col-sm-10">
                                              <v-card>
                                                  <v-tabs v-model="tabLanguageEditor" color="deep-purple-accent-4">
                                                      <v-tab value="editorDataEn">Ingles</v-tab>
                                                      <v-tab value="editorDataEs">Español</v-tab>
                                                      <v-tab value="editorDataFr">Frances</v-tab>
                                                  </v-tabs>
                                                  <v-window v-model="tabLanguageEditor">
                                                      <div id="editor">
                                                          <ckeditor v-if="tabLanguageEditor === 'editorDataEn'"
                                                              id="snippet-classic-editor-en"
                                                              :editor="editor"
                                                              v-model="editorDataEn"
                                                              :config="editorConfig"
                                                          ></ckeditor>
                                                          <ckeditor v-else-if="tabLanguageEditor === 'editorDataEs'"
                                                              id="snippet-classic-editor-es"
                                                              :editor="editor"
                                                              v-model="editorDataEs"
                                                              :config="editorConfig"
                                                          ></ckeditor>
                                                          <ckeditor v-else-if="tabLanguageEditor === 'editorDataFr'"
                                                              id="snippet-classic-editor-fr"
                                                              :editor="editor"
                                                              v-model="editorDataFr"
                                                              :config="editorConfig"
                                                          ></ckeditor>
                                                      </div>
                                                  </v-window>
                                              </v-card>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <br /><br />
                              <div class="row">
                                  <div class="col-12">
                                      <div class="mb-4 row align-items-center">
                                          <label class="col-sm-2 col-form-label form-label-title">New Image</label>
                                          <div class="col-sm-10">
                                              <v-file-input v-model="newImage" counter placeholder="Select your image" />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <!-- <div class="row">
                                  <div class="col-12">
                                      <div class="mb-4 row align-items-center">
                                          <label class="col-sm-2 col-form-label form-label-title">Image</label>
                                          <div class="col-sm-10">
                                              <v-img :src="srcImage"></v-img>
                                          </div>
                                      </div>
                                  </div>
                              </div> -->
                              <div class="row">
                                    <div class="mb-4 row align-items-center">
                                        <label class="form-label-title col-sm-2 mb-0">Description image (SEO)</label>
                                        <div class="col-sm-10">
                                            <v-text-field placeholder="Author" v-model="altImage"></v-text-field>
                                        </div>
                                    </div>
                                </div>

                              
                              <div class="row">
                                  <div class="col-12">
                                      <div class="mb-4 row align-items-center">
                                          <label class="col-sm-2 col-form-label form-label-title">Active</label>
                                          <div class="col-sm-10">
                                              <v-checkbox v-model="active" label="Active"></v-checkbox>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div class="d-flex flex-column">
                                  <v-btn class="mt-4" color="success" block @click="validate"> Create </v-btn>
                              </div>
                          </v-form>
                      </div>

                      <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'

export default {
  name: 'app',
  title: 'Create Blog',
  watch: {
      editorData() {
          
      },
      newImage() {
         
      }
  },
  data() {
      return {
          id: null,
          author: null,

          tabLanguageTitle: null,
          titleEn: '',
          titleEs: '',
          titleFr: '',

          tabLanguageEditor: null,
          editorDataEn: '',
          editorDataEs: '',
          editorDataFr: '',

          editor: ClassicEditor,
          editorConfig: {
              toolbar: {
                  items: ['undo', 'redo', '|', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote']
              },
              language: 'es'
          },
          newImage: [],
          srcImage: null,
          altImage: null,
          active: false,

          messageError: '',
          typeOfMessage: ''
      }
  },
  methods: {
      async validate() {
          const { valid } = await this.$refs.form.validate()

          if (valid) {
              this.createBlog()
          } else {
              alert('Faltan parametros')
          }
      },
      resetValidation() {
          this.$refs.form.resetValidation()
      },
      createBlog() {
          let newObject = {
              author: this.author,
              title: { en: this.titleEn, es: this.titleEs, fr: this.titleFr },              //MultiIdioma
              content: { en: this.editorDataEn, es: this.editorDataEs, fr: this.editorDataFr },  //MultiIdioma
              altImage: this.altImage,
              //slug: Autocalcular
              //Imagen

              active: this.active
          }

          const formData = new FormData();
          formData.append('form', JSON.stringify(newObject));

          // Agregar los archivos al objeto FormData
          formData.append('files', this.newImage[0]);
              
          
          /* axios({
              url: process.env.VUE_APP_URL_API_BASE + '/blog/update',
              method: 'POST',
              data: formData,
              responseType: 'json',
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          }) */
          axios.post(process.env.VUE_APP_URL_API_BASE + '/blog/create', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              },
              responseType: 'json' // Especifica el tipo de respuesta
          })
              .then((response) => {
                  if (response.data.error) {
                      this.messageError = response.data.message
                      this.typeOfMessage = 'error'
                  } else {
                      this.messageError = response.data.message
                      this.typeOfMessage = 'success'
                  }
                  setTimeout(() => (this.messageError = ''), 10000)
              })
              .catch((error) => {
                  this.messageError = 'Error! El blog no se ha modificado.'
                  this.typeOfMessage = 'error'
                  setTimeout(() => (this.messageError = ''), 10000)
                  console.error(error)
              })
      }
  },
  async created() {
      
  }
}
</script>

<style></style>
